import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider as MobxProvider } from "mobx-react";
import { hot } from "react-hot-loader/root";
import Layout from "./layouts/Layout";
import AppRoutes from "./Routes";
import stores from "./stores";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import he from "./locale/he.json";
import en from "./locale/en.json";
import GlobalStyles from "./UI/GlobalStyles";
import { MobileProvider } from "./utils/mobile";
import { MessageNotificationProvider } from "./components/MessageNotification";

let REACT_APP_API = window.env.REACT_APP_API;
let REACT_APP_FIREBASE_PROJECT_ID = window.env.REACT_APP_FIREBASE_PROJECT_ID;
let REACT_APP_FIREBASE_API_KEY = window.env.REACT_APP_FIREBASE_API_KEY;
let REACT_APP_FIREBASE_AUTH_DOMAIN = window.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
let REACT_APP_FIREBASE_STORAGE_BUCKET =
  window.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
let REACT_APP_FIREBASE_MESSAGING_SENDER_ID =
  window.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
let REACT_APP_FIREBASE_APP_ID = window.env.REACT_APP_FIREBASE_APP_ID;
let REACT_APP_FIREBASE_MEASUREMENT_ID =
  window.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

console.info("Application starting with the following environment variables:");
console.info("REACT_APP_API:", REACT_APP_API);
console.info("REACT_APP_FIREBASE_PROJECT_ID:", REACT_APP_FIREBASE_PROJECT_ID);
console.info(
  "REACT_APP_FIREBASE_API_KEY:",
  REACT_APP_FIREBASE_API_KEY ? "***** (hidden)" : "Not Set",
);
console.info("REACT_APP_FIREBASE_AUTH_DOMAIN:", REACT_APP_FIREBASE_AUTH_DOMAIN);
console.info(
  "REACT_APP_FIREBASE_STORAGE_BUCKET:",
  REACT_APP_FIREBASE_STORAGE_BUCKET,
);
console.info(
  "REACT_APP_FIREBASE_MESSAGING_SENDER_ID:",
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
);
console.info("REACT_APP_FIREBASE_APP_ID:", REACT_APP_FIREBASE_APP_ID);
console.info(
  "REACT_APP_FIREBASE_MEASUREMENT_ID:",
  REACT_APP_FIREBASE_MEASUREMENT_ID,
);

const getSavedLanguage = () => {
  const localStorageLang = window.localStorage.getItem(
    "coralis-language-preference",
  );
  if (localStorageLang) {
    return localStorageLang;
  }

  try {
    const sessionStorageUser = window.sessionStorage.getItem(
      "coralis-tenants-user",
    );
    if (sessionStorageUser) {
      const parsed = JSON.parse(sessionStorageUser);
      if (parsed?.language) {
        return parsed.language;
      }
    }
  } catch (e) {
    // Ignore parsing errors
  }

  return "he";
};

i18next.use(initReactI18next).init({
  resources: { en: en, he: he },
  fallbackLng: ["he", "en"],
  lng: getSavedLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

const App = () => {
  useEffect(() => {
    document.title = "Coralis";
    const currentThemeString = JSON.parse(
      localStorage.getItem("coralis-tenants-storeuser"),
    )?.selectedTheme;
    if (currentThemeString) {
      // const currentTheme = getCurrentTheme(currentThemeString);
      // setSelectedTheme(currentTheme);
    }
  }, []);

  return (
    <MobxProvider {...stores}>
      <GlobalStyles />
      <BrowserRouter>
        <MobileProvider isMobile={document.body.offsetWidth < 799}>
          <MessageNotificationProvider>
            <Layout>
              <AppRoutes />
            </Layout>
          </MessageNotificationProvider>
        </MobileProvider>
      </BrowserRouter>
    </MobxProvider>
  );
};

export default hot(App);
